import React from "react";
import { motion } from "framer-motion";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/ServiceCharter.css";

const ServiceCharter = () => {
  const rniFadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
  };

  return (
    <div className="rni-charter-root">
      <TopBar />
      <Navbar />

      {/* --- BOLD HEADER --- */}
      <section className="rni-charter-hero">
        <div className="rni-hero-inner">
          <motion.div initial="hidden" animate="visible" variants={rniFadeUp}>
            <span className="rni-label-pill">SERVICE EXCELLENCE</span>
            <h1 className="rni-massive-header">
              Our Promise <br /> 
              <span className="rni-text-blue">To You.</span>
            </h1>
            <p className="rni-hero-desc">
              We are committed to providing an outstanding level of international standard service 
              to our corporate and individual clientele.
            </p>
          </motion.div>
        </div>
      </section>

      {/* --- THE THREE PILLARS --- */}
      <section className="rni-pillars-section">
        <div className="rni-pillars-container">
          <div className="rni-pillar-box">
            <div className="rni-pillar-num">01</div>
            <h3>Quality & Professionalism</h3>
            <p>Our commitment is to provide quality professional service through qualified and highly experienced personnel.</p>
          </div>
          <div className="rni-pillar-box rni-pillar-dark">
            <div className="rni-pillar-num">02</div>
            <h3>Sector Expertise</h3>
            <p>Providing specialized insurance solutions for agriculture, real estate, manufacturing, and trading sectors.</p>
          </div>
          <div className="rni-pillar-box">
            <div className="rni-pillar-num">03</div>
            <h3>Future Security</h3>
            <p>Upholding our motto "Securing your future," where your safety is a priority, not an option.</p>
          </div>
        </div>
      </section>

      {/* --- COMMITMENT TIMELINE --- */}
      <section className="rni-timeline-section">
        <div className="rni-timeline-wrap">
          <h2 className="rni-section-heading">Our Service <span className="rni-text-blue">Standards</span></h2>
          
          <div className="rni-timeline-item">
            <div className="rni-time-dot"></div>
            <div className="rni-time-content">
              <h4>Risk Assessment</h4>
              <p>Detailed and comprehensive evaluations to ensure you receive the right coverage.</p>
            </div>
          </div>

          <div className="rni-timeline-item">
            <div className="rni-time-dot"></div>
            <div className="rni-time-content">
              <h4>Competitive Pricing</h4>
              <p>We leverage our industry experience to provide the best possible rates in the region.</p>
            </div>
          </div>

          <div className="rni-timeline-item">
            <div className="rni-time-dot"></div>
            <div className="rni-time-content">
              <h4>Regulatory Transparency</h4>
              <p>Full compliance with the Insurance Regulatory Authority with license validity through 2026.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- ESCALATION & SUPPORT LEAD --- */}
      <section className="rni-support-section">
        <div className="rni-support-card">
            <span className="rni-support-tag">DIRECT SUPPORT</span>
            <h2>Accountability Matters</h2>
            <p>For any service-related inquiries or technical issues, please reach out to our IT lead:</p>
            <div className="rni-lead-contact">
                <span className="rni-lead-name">Vansh Patel</span>
                <span className="rni-lead-phone">0748 660944</span>
            </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiceCharter;